import packageJson from '../../../package.json';
import { cn } from '../../lib/utils';
import { useLocation } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const pathname = useLocation().pathname;

  const isAdmin = pathname.startsWith("/admin");
  
  return (
    <footer className={cn("w-full py-8 border-t border-gray-400", isAdmin ? "fixed bottom-0 backdrop-blur-[8px] bg-white/70" : "bg-secondary_background")}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center text-sm text-secondary_text">
          <div className="mb-2 md:mb-0">
            <span>Version: {packageJson.version}</span>
          </div>
          <div>
            <span>© {currentYear} Grwan Group. All rights reserved.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
